import { createContext, useState } from 'react';

import { useQuery } from 'react-query';
import getWebsiteSettings from 'api/settings/getWebsiteSettings';

import { QUERY_IDS } from 'api';
import FullPageLoader from 'components/FullPageLoader';
import { getCookie, setCookie } from 'utils/cookies';
import { COOKIE_POLICY_ACCEPTED } from 'constants/constants';

const { GET_WEBSITE_SETTINGS } = QUERY_IDS;

const WebsiteSettingsContext = createContext();

const WebsiteSettingsContextProvider = ({ children }) => {
  const cookiePolicy = getCookie(COOKIE_POLICY_ACCEPTED);
  const [cookiesPolicyAccepted, setCookiesPolicyAccepted] = useState(cookiePolicy);
  const { data: websiteSettings, isLoading: isGettingWebsiteSettings } = useQuery(
    GET_WEBSITE_SETTINGS,
    getWebsiteSettings,
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );

  const setPolicyCookie = ({ name = COOKIE_POLICY_ACCEPTED, value = '' }) => {
    setCookiesPolicyAccepted(value);
    setCookie(name, value);
  };

  if (isGettingWebsiteSettings) {
    return <FullPageLoader />;
  }
  return (
    <WebsiteSettingsContext.Provider
      value={{
        ...websiteSettings,
        cookiesPolicyAccepted,
        setCookiesPolicyAccepted,
        setPolicyCookie,
      }}
    >
      {children}
    </WebsiteSettingsContext.Provider>
  );
};

export { WebsiteSettingsContext };
export default WebsiteSettingsContextProvider;
